import Services from "api/ProjectApiConsumer";

export function getData(urlParam, obj) {
  return Services.managerialService.getData(undefined, obj, urlParam);
}

export function saveData(obj) {
  return Services.managerialService.saveData(obj);
}

export function deleteByType(urlParam) {
  return Services.managerialService.deleteByType(
    undefined,
    undefined,
    urlParam
  );
}

export function saveCompany(obj) {
  return Services.managerialService.saveCompany(obj);
}

export function getCompanies() {
  return Services.managerialService.getCompanies();
}

export function deleteCompany(urlParam) {
  return Services.managerialService.deleteCompany(
    undefined,
    undefined,
    urlParam
  );
}

export function updateCompany(urlParam, body) {
  return Services.managerialService.updateCompany(body, undefined, urlParam);
}

export function getComments(id) {
  return Services.managerialService.getComments(undefined, undefined, id);
}

export function saveComments(id, body) {
  return Services.managerialService.saveComments(body, undefined, id);
}

export function getDocuments(id) {
  return Services.managerialService.getDocuments(undefined, undefined, id);
}

export function saveDocuments(id, body) {
  return Services.managerialService.saveDocuments(body, undefined, id);
}
export function deleteDocuments(id, body) {
  return Services.managerialService.deleteDocuments(undefined, undefined, id);
}
